<template>
    <div>
        <!--聊天室列表-->
        <div class="store_chatroom">
            <!--表頭-->
            <div class="page_top">
                <div class="title">
                    <i class="icon" id="icon" @click="back()"></i>
                    <span class="header-text">{{ this.showName }}</span>
                </div>
            </div>
            <!--滾動內容頁-->
            <div class="sh_page_padding d-flex flex-column">
                <!--訊息內容-->
                <div style="overflow-y: auto; background-color: #F2F6FC; overflow-x:hidden " class="h-100"
                     id="message-container" @scroll="handleScroll" v-infinite-scroll="isRead" infinite-scroll-delay="2000">
                    <div class="w-100 ">
                        <div class="d-flex justify-content-center my-2" v-if="topLoading">
                            <i class="el-icon-loading"></i>
                        </div>
                        <div v-for="(message,index) in messages" :key="index">
                            <!--日期顯示-->
                            <div class="d-flex justify-content-center" v-if="isFirstMessageOfDay(index)">
                                <el-divider>
                                    <el-tag type="info">{{ moment(message.date).format('YYYY-MM-DD') }}
                                        {{ moment(message.date).format('dddd') }}
                                    </el-tag>
                                </el-divider>
                            </div>
                            <!--其他人的訊息-->
                            <div class="d-flex justify-content-start" v-if="message.role == 'business'">
                                <div class="m-2 text-wrap lh-base bg-white rounded-3 p-2 message-other">
                                <span v-if="message.type=='message'">
                                    {{ message.message }}
                                </span>
                                    <div v-if="message.type=='image'">
                                        <el-image style="max-width: 300px;" :src="getImageUrl(message.message)"
                                                  :preview-src-list="[getImageUrl(message.message)]"
                                                  @load="imageLoaded"
                                        >
                                        </el-image>
                                    </div>
                                    <div class="d-flex justify-content-end" style="color: #909399;font-size: 12px">
                                        <span>{{ moment(message.date).format('LT') }}</span>
                                    </div>
                                </div>
                            </div>

                            <!--自己的訊息-->
                            <div class="d-flex justify-content-end" v-if="message.role == 'member'">
                                <div class="m-2 text-wrap lh-base  rounded-3 p-2 message-my">
                                    <span v-if="message.type=='message'">{{ message.message }}</span>
                                    <div v-if="message.type=='image'">
                                        <el-image style="max-width: 300px;" :src="getImageUrl(message.message)"
                                                  :preview-src-list="[getImageUrl(message.message)]"
                                                  @load="imageLoaded"
                                        >

                                        </el-image>
                                    </div>
                                    <div class="d-flex justify-content-end" style="color: #909399;font-size: 12px">
                                        <span>{{ moment(message.date).format('LT') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center my-2" v-if="loading">
                            <i class="el-icon-loading"></i>
                        </div>
                    </div>
                </div>
                <!--訊息輸入框-->
                <div class=" my-2">
                    <div class="d-flex justify-content-between align-items-center">
                        <el-upload :show-file-list="false" action="/api/store/chatroom/image/send" :headers="headers"
                                   ref="imgUpload"
                                   :on-change="snedImg"
                                   :auto-upload="false"
                                   :on-success="uploadSuccess"
                                   :on-error="uploadError"
                                   :data="uploadData"
                                   :before-upload="beforeUpload"
                                   accept="image/*"
                        >
                            <i class="far fa-image mx-2" style="font-size: 28px;color: #606266"></i>
                        </el-upload>
                        <el-input
                            class="ms-1 me-1" type="textarea" :autosize="{ minRows: 1, maxRows: 4}"
                            v-model="messageData.message"
                            placeholder="請輸入訊息">
                        </el-input>
                        <el-button type="primary" style="min-width: 60px" class="me-1" icon="el-icon-edit " size="small"
                                   @click="sendMessage"></el-button>

                    </div>
                </div>
                <!--回到底部按鈕-->
                <div class="position-absolute" style="bottom: 60px;right: 15px">
                    <el-button type="info" icon="fas fa-caret-down" size="mini" @click="goBottom"
                               v-if="goBottomButton"></el-button>
                </div>
                <div class="position-absolute w-100" style="bottom: 46px;background-color: rgba(0,0,0,0.3)"
                     v-if="newMessage">
                    <div class="d-flex justify-content-center">
                        <span class="text-white my-2" style="font-size: 14px">有新訊息..</span>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<style>

.el-divider__text.is-center {
    background-color: #F2F6FC;
}

.message-my {
    max-width: 80%;
    background-color: rgb(225, 243, 216);
}

.message-other {
    max-width: 80%;
}

.el-icon-position:focus {
    color: #409EFF;
}
</style>
<script>
import moment from 'moment/min/moment-with-locales'
import FN from '@/components/fn'
import {getStorage, setStorage} from "@/util";

export default {
    components: {},
    mixins: [FN],
    data() {
        return {
            messageData: {
                message: "",
                type: "",
                channelId: "",
            },
            messages: [],
            goBottomButton: false,
            moment: moment,
            dates: [],
            loading: false,
            channel: "",
            page: 1,
            lastPage: 1,
            topLoading: true,
            first: true,
            headers: {
                Authorization: '',
            },
            showName: "",
            lastUploadFileName: "",
            uploadData: {
                channelId: '',
            },
            newMessage: false,
            token: "",

        }
    },
    mounted() {
        moment.locale('zh-tw')
        this.messageData.channelId = this.$route.params.id;
        this.uploadData.channelId = this.$route.params.id;
        this.channel = this.$route.params.channel;
        this.showName = decodeURIComponent(this.$route.params.showName);
        this.unsubscribe();
        this.subscribe();
        this.getHistoryMessage();
        this.goBottom();

    },
    methods: {
        /** 滾動監聽 */
        handleScroll() {
            let container = this.$el.querySelector("#message-container");

            /** 判斷是否顯示回到底部按鈕 */
            if ((container.scrollTop + container.offsetHeight + 100) < container.scrollHeight) {
                this.goBottomButton = true;

            } else {
                this.goBottomButton = false;
            }
            // console.log(container.offsetHeight)
            if((container.scrollTop+container.offsetHeight +10)> container.scrollHeight){
                this.newMessage = false;
            }
            /** 判斷是否取得歷史訊息 */
            if (container.scrollTop == 0) {
                this.getHistoryMessage();
            }


        },
        /** 回上一頁 */
        back() {
            this.$router.go(-1)
        },
        /** 回底部 */
        goBottom() {
            let container = this.$el.querySelector("#message-container");
            container.scrollTop = container.scrollHeight;
        },
        /** 判斷是否為當天第一筆訊息 */
        isFirstMessageOfDay(index) {
            if (index == 0) {
                return true;
            }
            let date = this.messages[index].date;
            let prevDate = this.messages[index - 1].date;
            if (moment(date).format('YYYY/MM/DD') != moment(prevDate).format('YYYY/MM/DD')) {
                return true;
            } else {
                return false;
            }
        },
        /**訂閱頻道 */
        subscribe() {
            let self = this;
            let token = getStorage('assessToken');
            this.$pusher.config.authEndpoint = '/chatroom/auth';
            this.$pusher.config.auth = {
                params: {
                    'token': token,
                    'channelId': this.messageData.channelId
                },
            };
            var channel = this.$pusher.subscribe('private-' + this.channel);

            channel.bind('App\\Events\\Store\\SendMessage', function (data) {
                self.messages.push(data);
                let container = self.$el.querySelector("#message-container");

                if (container.scrollHeight > container.clientHeight) {
                    self.newMessage = true;
                }

            });
        },
        /** 取消訂閱 */
        unsubscribe() {
            this.$pusher.unsubscribe(this.channel);
        },
        /** 送出訊息 */
        sendMessage() {
            this.messageData.type = 1;
            if (this.messageData.message == '') {
                return;
            }
            this.loading = true;
            this.FETCH({
                key: 'STORE_SEND_MESSAGE',
                ...this.messageData
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.sendMessage)
                } else if (+(res || {}).code === 0) {
                    console.log('send ok');
                } else {
                    console.log(res);
                    this.$message('網路異常，請稍後再試');
                }
                this.loading = false;
            });
            this.messageData.message = '';

        },
        /** 取得歷史訊息 */
        getHistoryMessage() {
            if (this.page > this.lastPage) {
                return;
            }
            this.topLoading = true;
            this.FETCH({
                key: 'GET_HISTORY_MESSAGE',
                page: this.page,
                channelId: this.messageData.channelId,
                limit: 10,
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.sendMessage)
                } else if (+(res || {}).code === 0) {
                    this.addMessage(res.pagination.data);
                    this.lastPage = res.pagination.last_page;
                    this.page++;
                } else {
                    this.$message('網路異常，請稍後再試');
                }

                this.topLoading = false;
            });
        },
        /** 新增訊息 */
        addMessage(newMessages) {
            newMessages.forEach((newMessage) => {
                if (!this.messages.some(message => message.id === newMessage.id)) {
                    this.messages.unshift(newMessage);
                }
            });
        },
        /** 更新TOKEN */
        async refreshToken() {
            //  取得refreshToken
            const token = getStorage('refreshToken');
            try {
                // 取得新的token
                const res = await this.FETCH({key: 'LOGIN_STATE', refreshToken: token});
                // 判斷是否成功
                if (res.code == 0) {
                    //  更新token
                    setStorage('assessToken', res.data.accessToken);
                    setStorage('refreshToken', res.data.refreshToken);
                    //  更新headers
                    this.headers.Authorization = getStorage('assessToken');
                    return true;
                } else {
                    //  登入逾時
                    this.$confirm('登入逾時', {showCancelButton: false, type: 'error'}).then(() => {
                        location.href = '/app/'
                    });
                    return false;
                }
            } catch (error) {
                // 处理错误信息
                console.error(error);
                return false;
            }
        },
        /** 上傳圖片 */
        async snedImg(file, fileList) {
            let refreshResult = await this.refreshToken()

            if (refreshResult == true) {
                this.$refs.imgUpload.submit();
            }
        },
        /** 圖片載入完成執行 */
        imageLoaded() {
            if (this.page == 2 || this.page == 1) {
                this.goBottom();
            }
        },
        /** 上傳圖片成功 */
        uploadSuccess(response, file, fileList) {

            console.log(response);
            if (response.code != 0) {
                this.$message('網路不穩定。請稍後再試，謝謝。')
                this.loading = false;
            }
            this.loading = false;
            this.goBottom();
        },
        /** 上傳圖片失敗 */
        uploadError(error, file, fileList) {
            console.log(error);
            this.$message('網路不穩定。請稍後再試，謝謝。')
            this.loading = false;
        },
        /** 取得圖片路徑 */
        getImageUrl(url) {
            let token = getStorage('assessToken');
            let path = url + '/' + token;
            return path;
        },
        /** 上傳圖片前驗證 */
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
            if (!isJPG) {
                this.$message.error('只能上傳圖片');
            }

            return isJPG;
        },
        /** 將訊息改為已讀 */
        isRead(){
            this.FETCH({
                key: 'MESSAGE_IS_READ',
                channelId: this.messageData.channelId,
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.isRead)
                } else if (+(res || {}).code === 0) {
                    console.log('is read');
                } else {
                    console.log(res);
                }
            });
        }

    },
    // 離開頁面時取消訂閱
    beforeRouteLeave(to, from, next) {
        const component = this;
        this.unsubscribe();
        next();
    }
    ,
    watch: {
        loading() {
            this.$nextTick(function () {
                this.goBottom();
            })
        },
        topLoading() {
            this.$nextTick(function () {
                let container = this.$el.querySelector("#message-container");
                container.scrollTop = 10;
                if (this.first) {
                    this.first = false;
                    this.goBottom();
                }
            })
        },

    },
}
</script>



